<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('new_bank_account') }}</h4>
        <h6>{{ $t('create_bank_account') }}</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/bank/account/head/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="submitHead" enctype="multipart/form-data">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">{{ $t('bank_account_number') }} <span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-model="heads.node"
                            class="form-control"
                            :placeholder="$t('bank_account_number')"
                          />
                          <div v-if="errors.node" class="text-danger mt-2">
                            <span>{{ errors.node }}</span>
                          </div>
                        </div>
                        <div v-if="errorMessage" class="text-danger mt-2">
                          {{ errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <div class="btn-addproduct mb-4">
            <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
            <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
          </div>
        </div>
      </form>

</div>
</template>


<script>
import Modal from "@/components/common/Modal.vue";
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
    Vue3Datepicker,
  },
  emits: ['select'],
  data() {
    return {
      heads: {
        node: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {

      async submitHead() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.heads.node.trim()) this.errors.node = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
            return;
        }

        try {

          // Send API request
          const response = await this.$axios.post(apiUrls.bank_account_head.post, this.heads );

          this.toast.success('Bank head successfully created!')

          // Redirect only after successful response
          this.$router.push('/bank/account/head/list');

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          this.errors = {};
          this.errorMessage = "";

          if (error.response) {
            // Backend field-specific errors
            if (error.response.data?.errors) {
              const backendErrors = error.response.data.errors;

              // Assign to Vue errors object (keep as array)
              Object.keys(backendErrors).forEach(key => {
                this.errors[key] = backendErrors[key];
              });
            }

            // Backend general error message (optional)
            if (error.response.data?.error) {
              this.errorMessage = error.response.data.error;
            }

          } else if (error.request) {
            this.errorMessage = "No response from server. Check network.";

          } else {
            this.errorMessage = error.message;
          }
        }
      },

      cancelForm() {
        this.$router.push('/bank/account/head/list');
      },

      resetForm() {
        // Reset form fields and errors
        this.heads = {
          node: '',
        };
        this.errors = {};
        this.errorMessage = "";
      }
    },

};
</script>
